var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDupeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FEEDF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.332 30.6562H20.1654C19.157 30.6562 18.332 29.8313 18.332 28.8229V19.6562C18.332 18.6479 19.157 17.8229 20.1654 17.8229H29.332C30.3404 17.8229 31.1654 18.6479 31.1654 19.6562V28.8229C31.1654 29.8313 30.3404 30.6562 29.332 30.6562ZM29.332 19.6562H20.1654V28.8229H29.332V19.6562Z",
    fill: "#EE46BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.832 14.1562H14.6654V23.3229H16.4987V25.1562H14.6654C13.657 25.1562 12.832 24.3313 12.832 23.3229V14.1562C12.832 13.1479 13.657 12.3229 14.6654 12.3229H23.832C24.8404 12.3229 25.6654 13.1479 25.6654 14.1562V15.9896H23.832V14.1562Z",
    fill: "#EE46BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDupeIcon);
export default __webpack_public_path__ + "static/media/Dupe-icon.7f2969df3cb8705383b4c7d1cbd9051b.svg";
export { ForwardRef as ReactComponent };